module.exports = __webpack_public_path__ + "static/media/09.bdfa572d.png";